import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=44d14722&scoped=true&"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=44d14722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d14722",
  null
  
)

component.options.__file = "MultipleChoiceQuestion.vue"
export default component.exports